module.exports = __webpack_public_path__ + "img/followup.2a957ef9.png";